import { createPinia } from 'pinia';

// 创建
const pinia = createPinia();

// 导出
export default pinia;
